<div class="col-md-3 col-12 mb-3">
    <div class="card">
        <div class="card-header">
            <div class="card-title mb-0">Company Setting</div>
        </div>
        <div class="card-body">
            <div class="mb-3">
                <label for="slogan" class="form-label">Company Slogan</label>
                <input type="text" class="form-control" id="slogan" [(ngModel)]="setting.slogan" placeholder="e.g. Your Trusted Partner">
                <div class="form-text">Displayed next to the company name in the admin header bar.</div>
            </div>

            <div class="mb-3">
                <label for="currency" class="form-label">Currency</label>
                <select class="form-control" [(ngModel)]="setting.currency">
                    <option [value]="'none'">Dont Show</option>
                    <option [value]="'RM'">RM</option>
                    <option [value]="'PGK'">PGK</option>
                    <option [value]="'$'">$</option>
                    <option [value]="'USD'">USD</option>
                    <option [value]="'S$'">S$</option>
                    <option [value]="'rp'">RP</option>
                    <option [value]="'฿'">฿</option>
                    <option [value]="'₫'">₫</option>
                    <option [value]="'K'">K</option>
                </select>
            </div>

            <div class="mb-3">
                <label for="consolidated_report_myr_rate" class="form-label">MYR Conversion Rate</label>
                <input type="number" class="form-control" id="consolidated_report_myr_rate"
                    [(ngModel)]="setting.consolidated_report_myr_rate" min="0.000001" step="0.000001"
                    placeholder="1 unit of this currency in MYR" />
                <div class="form-text">Used by consolidated reports. RM/MYR and “Don't Show” default to 1.00.</div>
            </div>

            <div class="mb-3">
                <label for="hide_dashboard_currency" class="form-label">Hide Dashboard Currency</label>
                <select class="form-control" [(ngModel)]="setting.hide_dashboard_currency">
                    <option [value]="'false'">Show</option>
                    <option [value]="'true'">Dont Show</option>
                </select>
            </div>

            <div class="mb-3">
                <label for="hide_actual_pay_to_customer" class="form-label">Hide Actual Pay to Customer on Whithdraw</label>
                <select class="form-control" [(ngModel)]="setting.hide_actual_pay_to_customer">
                    <option [value]="'false'">Show</option>
                    <option [value]="'true'">Dont Show</option>
                </select>
            </div>
            
            <div class="mb-3">
                <label for="timezone" class="form-label">Timezone</label>
                <select class="form-control" [(ngModel)]="setting.timezone">
                    <option [value]="'+05:30'">+05:30 (IST)</option>
                    <option [value]="'+07:00'">+07:00 (ICT)</option>
                    <option [value]="'+08:00'">+08:00 (MYT/SGT)</option>
                    <option [value]="'+09:00'">+09:00 (JST/KST)</option>
                    <option [value]="'+10:00'">+10:00 (AEST)</option>
                    <option [value]="'-05:00'">-05:00 (EST)</option>
                    <option [value]="'+00:00'">+00:00 (UTC)</option>
                </select>
            </div>
            <hr/>
            <div class="mb-3">
                <label for="enabled_point" class="form-label">Enabled Point</label>
                <select class="form-control" [(ngModel)]="setting.enabled_point">
                    <option [value]="'true'">Yes</option>
                    <option [value]="'false'">No</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="credit_calculation_method" class="form-label">Auto Point Calculation</label>
                <select class="form-control" [(ngModel)]="setting.credit_calculation_method">
                    <option [value]="'auto'">Auto</option>
                    <option [value]="'manual'">Manual</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="credit_calculation_rate" class="form-label">Auto Point Rate (%)</label>
                <input type="number" class="form-control" [(ngModel)]="setting.credit_calculation_rate" />
            </div>
            <hr/>
            <div class="mb-3">
                <label for="rebate_calculation_method" class="form-label">Auto Rebate Calculation</label>
                <select class="form-control" [(ngModel)]="setting.rebate_calculation_method">
                    <option [value]="'auto'">Auto</option>
                    <option [value]="'manual'">Manual</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="rebate_calculation_rate" class="form-label">Auto Rebate Rate (%)</label>
                <input type="number" class="form-control" [(ngModel)]="setting.rebate_calculation_rate" />
            </div>
            <hr/>
            <div class="mb-3">
                <label for="enabled_finance_charge" class="form-label">Enabled Financial Charge Calculation</label>
                <select class="form-control" [(ngModel)]="setting.enabled_finance_charge">
                    <option [value]="'true'">Yes</option>
                    <option [value]="'false'">No</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="finance_charge_rate" class="form-label">Finance Charge Rate (Fixed Rate)</label>
                <input type="number" class="form-control" [(ngModel)]="setting.finance_charge_rate" />
            </div>

            <div class="mb-3">
                <app-checbox [setData]="setting" [key]="'summary_report_include_today_data'" [title]="'Summary Report Include Today Data'" [value]="true"></app-checbox>
                <p class="mb-0 hint">If you enable this, the summary report will include today's data. But the data loading time will be longer.</p>
            </div>
            <hr/>
            <div class="mb-3">
                <label for="allow_edit_withdraw_balance" class="form-label">Allow Edit Withdraw Amount</label>
                <select class="form-control" [(ngModel)]="setting.allow_edit_withdraw_balance">
                    <option [value]="'true'">Yes</option>
                    <option [value]="'false'">No</option>
                </select>
                <p class="mb-0 hint">When enabled, admins can lower a player's withdraw amount during approval (never above the requested value). The trimmed difference is refunded to the player wallet on submit.</p>
            </div>
            <hr/>
            <div class="mb-3">
                <app-checbox [setData]="setting" [key]="'panel_hide_nonpublic_banks'" [title]="'Hide Do-Not-Show Banks from Topup/Withdraw Dropdown'" [value]="true"></app-checbox>
                <p class="mb-0 hint">When enabled, banks marked <strong>Show at App = Do Not Show</strong> in Bank Management are hidden from the deposit/withdraw <strong>bank dropdowns</strong> in the panel (Manual, Transfer, and quick Topup/Withdraw). The Bank Summary/balance table still lists every bank, and this does not change what players see in the app. Leave off to show all active banks (default).</p>
            </div>
            <hr/>
            <div class="mb-2">
                <div class="fw-bold text-primary">Agent Offline Reminder</div>
                <p class="mb-0 hint">Checks every minute and alerts you when an Agent reaches the inactivity limit. Each inactive spell triggers one panel and push notification.</p>
            </div>
            <div class="mb-3">
                <label for="agent_offline_reminder_minutes" class="form-label">Inactivity Limit (Minutes)</label>
                <input type="number" min="0" max="525600" step="1" class="form-control" id="agent_offline_reminder_minutes"
                    [(ngModel)]="setting.agent_offline_reminder_minutes" placeholder="0 = disabled">
                <p class="mb-0 hint">For example, 30 means half an hour. Use 0 to disable. Agents that never logged in are measured from registration.</p>
            </div>
            <hr/>
            <div class="mb-2">
                <div class="fw-bold text-primary">Agent Withdrawal</div>
                <p class="mb-0 hint">Controls for agents cashing out their commission wallet.</p>
            </div>
            <div class="mb-3">
                <label for="enable_agent_commission_withdraw" class="form-label">Allow Agent Commission Withdrawal</label>
                <select class="form-control" [(ngModel)]="setting.enable_agent_commission_withdraw">
                    <option [value]="'true'">Yes</option>
                    <option [value]="'false'">No</option>
                </select>
                <p class="mb-0 hint">When enabled, agents can request to withdraw (cash out) their agent commission wallet from the front app. Each request is reserved immediately and must be approved on the <strong>Agent Withdraw</strong> screen, where you choose which company bank to pay from (or mark it a cash payout). Rejecting a request refunds the reserved commission.</p>
            </div>
            <div class="mb-3">
                <label for="agent_commission_withdraw_min" class="form-label">Minimum Agent Withdrawal Amount</label>
                <input type="number" min="0" step="0.01" class="form-control" [(ngModel)]="setting.agent_commission_withdraw_min" placeholder="0 = no minimum">
                <p class="mb-0 hint">Optional. The smallest amount an agent may request in a single withdrawal. Leave blank or 0 for no minimum.</p>
            </div>
            <hr/>
            <div class="mb-2">
                <div class="fw-bold text-primary">Company Override Rate</div>
                <p class="mb-0 hint">The company-wide override &mdash; the share the <strong>company itself</strong> keeps off the whole agent-commission pool before the remainder is paid down the agent tree. Applies to red-share / formula-commission companies.</p>
            </div>
            <div class="mb-3">
                <label for="agent_company_bucket_rate_pct" class="form-label">Company Override (%)</label>
                <input type="number" min="0" max="100" step="0.01" class="form-control" id="agent_company_bucket_rate_pct" [(ngModel)]="setting.agent_company_bucket_rate_pct" placeholder="0 = company keeps nothing">
                <p class="mb-0 hint">Percentage the company retains from each commission component generated across the whole company; the agent tree shares the remainder. Example: <strong>30</strong> &rarr; the company keeps 30%, agents split the other 70%. Stored internally as a 0&ndash;1 fraction (30 = 0.3). Leave blank or 0 to disable.</p>
            </div>
            <hr/>
            <div class="mb-3">
                <label for="enable_level_purchase_bank_transfer" class="form-label">Allow Buy-Member-Level Bank Transfer</label>
                <select class="form-control" [(ngModel)]="setting.enable_level_purchase_bank_transfer">
                    <option [value]="'true'">Yes</option>
                    <option [value]="'false'">No</option>
                </select>
                <p class="mb-0 hint">When enabled, an agent registering a sub-agent can choose <strong>Manual Bank Transfer</strong> to buy a member level. Instead of paying from their wallet, this creates a <strong>pending order</strong> (no sub-agent yet) that must be approved on the <strong>Agent Level Purchase</strong> screen, where you verify the bank transfer; on approval the sub-agent is created and the wallet credit granted. When off, only the Agent Wallet method works.</p>
            </div>
            <div class="mb-3">
                <label for="withdraw_trim_step" class="form-label">Withdraw Trim Step</label>
                <select class="form-control" [(ngModel)]="setting.withdraw_trim_step">
                    <option *ngFor="let opt of trim_step_options" [value]="opt">{{opt}}</option>
                </select>
                <p class="mb-0 hint">The rounding granularity used by the trim button on the withdraw screen. 1 trims down to the nearest whole number (79.30 &rarr; 79); 5 trims down to the nearest lower 5 (79.30 &rarr; 75); 10 to the nearest lower 10. The trim always lands strictly below the current amount. Defaults to 1.</p>
            </div>
            <hr/>
            <div class="mb-2"><strong>Transfer Game Page</strong></div>
            <div class="mb-3">
                <label for="transfer_game_step_numbers" class="form-label">Show Step Numbers (1-2-3)</label>
                <select class="form-control" [(ngModel)]="setting.transfer_game_step_numbers">
                    <option [value]="'false'">No</option>
                    <option [value]="'true'">Yes</option>
                </select>
                <p class="mb-0 hint">Shows numbered step badges on the transfer-game page to guide players: <strong>1</strong> Topup &rarr; <strong>2</strong> copy login &amp; password &rarr; <strong>3</strong> login the game platform &amp; play.</p>
            </div>
            <div class="mb-3">
                <label for="transfer_game_hide_deposit" class="form-label">Hide Deposit Shortcut</label>
                <select class="form-control" [(ngModel)]="setting.transfer_game_hide_deposit">
                    <option [value]="'false'">No</option>
                    <option [value]="'true'">Yes</option>
                </select>
                <p class="mb-0 hint">Hides the top-right <strong>Deposit</strong> shortcut on the transfer-game page.</p>
            </div>
            <div class="mb-3">
                <label for="transfer_game_hide_download" class="form-label">Hide App Download Buttons</label>
                <select class="form-control" [(ngModel)]="setting.transfer_game_hide_download">
                    <option [value]="'false'">No</option>
                    <option [value]="'true'">Yes</option>
                </select>
                <p class="mb-0 hint">Hides the <strong>Android</strong> / <strong>iOS</strong> app-download buttons on the transfer-game page.</p>
            </div>
            <div class="mb-3">
                <label for="transfer_game_auto_topup" class="form-label">Auto-open Topup Modal</label>
                <select class="form-control" [(ngModel)]="setting.transfer_game_auto_topup">
                    <option [value]="'true'">Yes</option>
                    <option [value]="'false'">No</option>
                </select>
                <p class="mb-0 hint">When the player opens a transfer game with main-wallet balance, the <strong>Transfer to Game Wallet</strong> popup opens automatically with the balance pre-filled. Set <strong>No</strong> to only open it when the player taps the Topup button. Default Yes.</p>
            </div>
            <div class="mb-3">
                <label for="transfer_game_modal_bg" class="form-label">Topup Modal Background</label>
                <div class="d-flex align-items-center gap-2">
                    <input type="color" class="form-control form-control-color" [(ngModel)]="setting.transfer_game_modal_bg">
                    <input type="text" class="form-control" style="max-width:120px" [(ngModel)]="setting.transfer_game_modal_bg" placeholder="#1f2430">
                </div>
                <p class="mb-0 hint">Background color of the <strong>Transfer to Game Wallet</strong> popup box. Default <code>#1f2430</code> (dark navy). Text color adjusts automatically for readability on light backgrounds.</p>
            </div>
            <div class="mb-3">
                <label for="transfer_game_overlay_color" class="form-label">Topup Modal Overlay Color</label>
                <div class="d-flex align-items-center gap-2">
                    <input type="color" class="form-control form-control-color" [(ngModel)]="setting.transfer_game_overlay_color">
                    <input type="text" class="form-control" style="max-width:120px" [(ngModel)]="setting.transfer_game_overlay_color" placeholder="#000000">
                </div>
                <p class="mb-0 hint">Color of the full-screen dimmer behind the popup. Default <code>#000000</code> (black).</p>
            </div>
            <div class="mb-3">
                <label for="transfer_game_overlay_opacity" class="form-label">Topup Modal Overlay Opacity</label>
                <select class="form-control" [(ngModel)]="setting.transfer_game_overlay_opacity">
                    <option [value]="'0.5'">0.5 (very see-through)</option>
                    <option [value]="'0.6'">0.6</option>
                    <option [value]="'0.7'">0.7</option>
                    <option [value]="'0.8'">0.8</option>
                    <option [value]="'0.85'">0.85</option>
                    <option [value]="'0.9'">0.9</option>
                    <option [value]="'0.92'">0.92 (default)</option>
                    <option [value]="'0.95'">0.95</option>
                    <option [value]="'1'">1 (solid)</option>
                </select>
                <p class="mb-0 hint">How solid the dimmer is. Below <strong>0.85</strong> the page behind starts showing through the popup (the earlier &quot;transparent background&quot; issue) &mdash; allowed, but not recommended.</p>
            </div>
        </div>
        <div class="card-footer">
            <button class="btn btn-sm w-100" (click)="update()" type="button" [disabled]="is_save">UPDATE</button>
        </div>
    </div>
</div>

<app-company-share-settings></app-company-share-settings>
